import React from "react";
import PortalCard from "./portal/PortalCard";
import { PortalButton } from "../components/portal/PortalButton";

export default function FeaturedCampaignWidget() {
  return (
    <PortalCard
      title="Featured Campaign"
      subtitle="A spotlight on a live project worth checking out."
      style={{ minHeight: "220px" }}
      variant="featured"
    >
      <div style={contentStyle}>
        <div style={bannerStyle}>Campaign Art</div>

        <div style={detailsStyle}>
          <p style={campaignTitleStyle}>Green Coats: Book One</p>
          <p style={campaignTextStyle}>
            A fantasy campaign currently building momentum. Join early and help
            bring it to life.
          </p>

          <div style={progressRowStyle}>
            <span style={progressLabelStyle}>62% funded</span>
            <span style={progressLabelStyle}>18 days left</span>
          </div>

          <div style={progressTrackStyle}>
            <div style={{ ...progressFillStyle, width: "62%" }} />
          </div>
        <PortalButton onClick={() => (window.location.href = "/fund")}>
          View Campaign
        </PortalButton>
        </div>
      </div>
    </PortalCard>
  );
}

const contentStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

const bannerStyle = {
  width: "100%",
  height: "120px",
  borderRadius: "10px",
  background: "#2b2b2b",
  border: "1px solid #444",
  color: "#888",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.9rem",
};

const detailsStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "0.65rem",
};

const campaignTitleStyle = {
  margin: 0,
  color: "rgb(66, 86, 111)",
  fontWeight: 700,
};

const campaignTextStyle = {
  margin: 0,
  color: "rgb(66, 86, 111)",
  lineHeight: 1.5,
};

const progressRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "1rem",
  fontSize: "0.9rem",
};

const progressLabelStyle = {
  color: "rgb(66, 86, 111)",
};

const progressTrackStyle = {
  width: "100%",
  height: "10px",
  background: "#ffff",
  borderRadius: "999px",
  overflow: "hidden",
};

const progressFillStyle = {
  height: "100%",
  background: "#114c96",
  borderRadius: "999px",
};

const secondaryLinkStyle = {
  display: "inline-block",
  textDecoration: "none",
  color: "#61dafb",
  border: "1px solid #61dafb",
  padding: "0.65rem 0.9rem",
  borderRadius: "10px",
  fontWeight: 700,
  width: "fit-content",
};